import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { visualizacaoModoDashboard } from '../../../../common/visualizacao-modo';
import {
  ApiError,
  AuthService,
  BaseFormService,
  ConfigService,
  MessageService,
  notCloseMessageOptions
} from '../../../../core';
import {
  isModoCentralCompraCadastro,
  isModoCentralCompraReferencia
} from '../../../../models/modo-central-compra';
import {
  OrigemLancamentoCadastro,
  origemLancamentoCadastroProspeccaoOutbound,
  origemLancamentoCadastroSogivendas
} from '../../../../models/origem-lancamento-cadastro';
import { periodicidadeAnual } from '../../../../shared';
import {
  ClienteGrupoEconomico,
  ClienteGrupoEconomicoCrudHttpService,
  ClienteGrupoEconomicoFilter,
  ClienteGrupoEconomicoSearchOrderBy,
  clienteGrupoEconomicoAtivo
} from '../../../cliente-grupo-economico';
import { moedaReal, moedas } from '../../../common/moeda';
import { ConfigCliente } from '../../../configuracoes/app/cliente';
import {
  ConfigEmpresa,
  isTipoMercadoMarca,
  isTipoMercadoUnidadeNegocio
} from '../../../configuracoes/app/empresa';
import { ConfigMeta } from '../../../configuracoes/app/meta';
import { KPI_CUSTOMER_SHARE, KPI_RAP, KPI_RAR } from '../../../kpis';
import {
  PessoaContatoComponent,
  contatoTipoCobranca,
  contatoTipoEntrega,
  contatoTipoPrincipal
} from '../../contato';
import {
  PessoaEnderecoUnicoComponent,
  enderecoTipoCobranca,
  enderecoTipoEntrega,
  enderecoTipoPrincipal
} from '../../endereco';
import { PessoaFormComponent } from '../../form';
import { Pessoa } from '../../pessoa';
import { pessoaTipoCadastro } from '../../pessoa-tipo-cadastro';
import { Representante } from '../../representante';
import { Usuario } from '../../../usuario';
import { EnumUsuarioEscopo } from '../../../usuario/enums/usuario-escopo.enum';
import { PessoaCrudHttpService } from '../../services';
import {
  isTipoPessoaCentralCompras,
  isTipoPessoaFisica,
  isTipoPessoaFisicaOuJuridica,
  isTipoPessoaJuridica
} from '../../tipo';
import {
  clienteCadastroCliente,
  clienteCadastroProspect,
  isClienteCadastroCliente,
  isClienteCadastroProspect
} from '../cadastro';
import { ClienteClassificacaoFormComponent } from '../classificacao';
import { Cliente } from '../cliente';
import { clienteAbcs } from '../cliente-abc';
import { isClienteRevisaoStatusPendente } from '../cliente-revisao-status';
import { ClienteConcorrenteComponent } from '../concorrente';
import { ClienteItemTipoComponent } from '../item-tipo';
import {
  ClienteAuthGuardService,
  ClienteCrudHttpService,
  ClienteSecundarioHttpService
} from '../services';
import {
  clienteSituacaoAtivo,
  clienteSituacaoNovo,
  clienteSituacoes
} from '../situacao';
import { ClienteTituloComponent } from '../titulo';
import { ClienteValidacoesHttpService } from '../validacoes';
// import { ClienteUnidadeNegocioComponent } from '../unidade-negocio';
import { IClientePortfolio } from 'app/domains/core/settings/portfolio/interfaces/cliente-portfolio-response.interface';
import { IPortfolioTree } from 'app/domains/shared/components/portfolio-categoria-tree-table/portfolio-categoria-tree-table.interface';
import { ISelectSettings } from 'app/domains/shared/components/select/models/select-settings.interface';
import { ToastService } from 'app/domains/shared/components/toast/services/toast.service';
import { IPickListSettings } from '../../../../domains/shared/components/pick-list/models/pick-list-settings.interface';
import type { ISeletorTagsSettings } from '../../../../domains/shared/components/seletor-tags/seletor-tags.component';
import {
  ITokenFieldSettings,
  ITokenItem
} from '../../../../domains/shared/components/tokenfield/tokenfield.component';
import { EnumCadastro } from '../../../../domains/shared/interfaces/cadastro.enum';
import { CampanhaSelectComponent } from '../../../campanhas/campanhas/components/select';
import {
  CampanhaSelect,
  mapToCampanha
} from '../../../campanhas/campanhas/components/select/campanha-select';
import { CampanhaViewEmbeddedComponent } from '../../../campanhas/campanhas/view/embedded';
import { ClassificacaoFaturamento } from '../../../classificacao-faturamento';
import { CanalVendaSelectComponent } from '../../../common/canais-venda/components/select';
import { CanalMidiaSocialSelectComponent } from '../../../common/canal-midia-social/components/select';
import { MEIFormComponent } from '../../../common/mei';
import { OrigemSelectComponent } from '../../../common/origens/components/select';
import { Origem, OrigemID } from '../../../common/origens/domain';
import { SimplesNacionalFormComponent } from '../../../common/simples-nacional';
import { ITags } from '../../../item';
import { ItemTipo, ItemTipoCrudHttpService } from '../../../item-tipo';
import { PessoaIPIFormComponent } from '../../components/ipi';
import { RepresentanteClassificacaoClienteHttpService } from '../../representante/classificacao-cliente';
import { PessoaTermoLGPDFormComponent } from '../../termo-lgpd/form';
import {
  ClienteAnaliseFinanceira,
  ClienteAnaliseFinanceiraAuthGuardService
} from '../analise-financeira';
import { ClienteAnaliseFinanceiraConcluirModalComponent } from '../analise-financeira/concluir-modal';
import { ClienteAnaliseFinanceiraRevisarModalComponent } from '../analise-financeira/revisar-modal';
import { ClienteArquivoComponent } from '../arquivos';
import { ClienteAtividadeComponent } from '../atividade';
import { ClienteCentralCompraParticipanteFormComponent } from '../central-compra';
import {
  CAMPANHAS_FILTER_STORAGE_KEY,
  CAMPANHAS_VISUALIZACAO_STORAGE_KEY
} from '../cliente-consts';
import { ClienteContratoFormComponent } from '../components/contrato/cliente-contrato-form.component';
import { ClienteLogisticaFormComponent } from '../components/logistica/cliente-logistica-form.component';
import { ClienteFinanceiroFormComponent } from '../financeiro';
import { ClienteIntegracaoEmpresasImportHttpService } from '../integracoes/empresas/services';
import { ClienteInternetFormComponent } from '../internet';
import { ClientePedidoComponent } from '../pedido/';
import { ClientePrazoPagamentoComponent } from '../prazo-pagamento';
import { ClienteRevisaoConfirmarComponent } from '../revisao';
import { ClienteUnidadeNegocio2Component } from '../unidade-negocio2';
import { ClientePreInsert } from './pre-insert/cliente-pre-insert';

interface Config {
  isPessoaFisica: boolean;
  isPessoaJuridica: boolean;
  isPessoaFisicaOuJuridica: boolean;
  isCentralCompras: boolean;
  canEditOrigem: boolean;
  isModoCentralCompraCadastro: boolean;
  isModoCentralCompraReferencia: boolean;
  isProspect: boolean;
  isShowContentTabTitulos: boolean;
  isOrigemPossuiCanalVenda?: boolean;
  isShowAtividades: boolean;
  // Moeda
  canEditMoeda: boolean;
  isMoedaRequired: boolean;
  // Requireds
  isDataFundacaoRequired: boolean;
  // Permissões
  canEdit: boolean;
  canEditClienteSegmentos: boolean;
  canEditFichaCadastral: boolean;
  canEditTipoFiscal: boolean;
}

interface ConfigAnaliseFinanceira {
  canVisualizarCliente: boolean;
  canRealizar: boolean;
}

@Component({
  selector: 'sgt-cliente-form',
  templateUrl: './cliente-form.component.html',
  styleUrls: ['cliente-form.component.less']
})
export class ClienteFormComponent implements OnInit {
  config: Config;
  isShowPreInsertForm = false;
  configEmpresa: ConfigEmpresa;
  configCliente: ConfigCliente;
  configMeta: ConfigMeta;
  isAdminitrador: boolean;
  isAtendente: boolean;
  isGerente: boolean;
  isRepresentante: boolean;
  isFinanceiro: boolean;

  escopoVinculo = EnumUsuarioEscopo.VINCULO;

  // KPIs
  KPI_RAP = KPI_RAP;
  KPI_CUSTOMER_SHARE = KPI_CUSTOMER_SHARE;
  KPI_RAR = KPI_RAR;

  /** Options */
  /** Se o component é embutido (Útil quando o compoment for utilizado dentro de outro ao invés de ser usado no route) */
  @Input() embedded = false;
  /** Se deve exibir o campo da origem */
  @Input() isShowOrigem = true;

  entity: Cliente;
  isLoading: boolean;
  editMode: boolean;
  tipoCadastro = pessoaTipoCadastro.cliente;
  isConsultandoCnpj = false;
  @ViewChild('form') form: NgForm;
  @ViewChild('origemSelect') origemSelect: OrigemSelectComponent;
  @ViewChild('campanhaOrigemSelect')
  campanhaOrigemSelect: CampanhaSelectComponent;
  @ViewChild('canalMidiaSocialSelect')
  canalMidiaSocialSelect: CanalMidiaSocialSelectComponent;
  @ViewChild('canalVendaOrigemSelect')
  canalVendaOrigemSelect: CanalVendaSelectComponent;
  @ViewChild('pessoaForm') pessoaForm: PessoaFormComponent;
  @ViewChild('simplesNacionalForm')
  simplesNacionalForm: SimplesNacionalFormComponent;
  @ViewChild('meiForm') meiForm: MEIFormComponent;
  @ViewChild('ipiForm') ipiForm: PessoaIPIFormComponent;
  @ViewChild('financeiroForm') financeiroForm: ClienteFinanceiroFormComponent;
  @ViewChild('contratoForm') contratoForm: ClienteContratoFormComponent;
  @ViewChild('logisticaForm') logisticaForm: ClienteLogisticaFormComponent;

  // Defaults
  /** Tipo de pessoa padrão ao inserir um novo cliente */
  tipoPessoaDefault: number = null;

  /** Form das classificações */
  @ViewChild('clienteClassificacaoForm')
  clienteClassificacaoForm: ClienteClassificacaoFormComponent;

  // Contatos
  contatoPrincipal = contatoTipoPrincipal.id;
  contatoCobranca = contatoTipoCobranca.id;
  contatoEntrega = contatoTipoEntrega.id;
  @ViewChild('pessoaOutrosContatosCadastro')
  pessoaOutrosContatosCadastro: PessoaContatoComponent;

  // Endereços
  enderecoPrincipal = enderecoTipoPrincipal.id;
  @ViewChild('pessoaEnderecoPrincipal')
  pessoaEnderecoPrincipal: PessoaEnderecoUnicoComponent;
  enderecoCobranca = enderecoTipoCobranca.id;
  @ViewChild('pessoaEnderecoCobranca')
  pessoaEnderecoCobranca: PessoaEnderecoUnicoComponent;
  enderecoEntrega = enderecoTipoEntrega.id;
  @ViewChild('pessoaEnderecoEntrega')
  pessoaEnderecoEntrega: PessoaEnderecoUnicoComponent;

  /** Form dos participantes da central de compras */
  @ViewChild('clienteCentralCompraParticipanteForm')
  clienteCentralCompraParticipanteForm: ClienteCentralCompraParticipanteFormComponent;
  @ViewChild('clienteConcorrenteForm')
  clienteConcorrenteForm: ClienteConcorrenteComponent;

  // Análise Financeira
  entityAnaliseFinanceira: ClienteAnaliseFinanceira;
  configAnaliseFinanceira: ConfigAnaliseFinanceira;
  @ViewChild('analiseFinanceiraConcluirModal')
  analiseFinanceiraConcluirModal: ClienteAnaliseFinanceiraConcluirModalComponent;
  @ViewChild('analiseFinanceiraRevisarModal')
  analiseFinanceiraRevisarModal: ClienteAnaliseFinanceiraRevisarModalComponent;

  @ViewChild('clienteTitulo') clienteTitulo: ClienteTituloComponent;
  @ViewChild('clienteArquivos') clienteArquivos: ClienteArquivoComponent;
  @ViewChild('clienteItemTipoForm')
  clienteItemTipoForm: ClienteItemTipoComponent;
  // @ViewChild('clienteUnidadeNegocio') clienteUnidadeNegocio: ClienteUnidadeNegocioComponent;
  @ViewChild('clienteUnidadeNegocio')
  clienteUnidadeNegocio: ClienteUnidadeNegocio2Component;
  @ViewChild('clientePrazoPagamentoCadastro')
  clientePrazoPagamentoCadastro: ClientePrazoPagamentoComponent;
  @ViewChild('clienteInternetForm')
  clienteInternetForm: ClienteInternetFormComponent;
  @ViewChild('clienteRevisaoConfirmar')
  clienteRevisaoConfirmar: ClienteRevisaoConfirmarComponent;
  @ViewChild('clienteAtividade') clienteAtividade: ClienteAtividadeComponent;
  @ViewChild('clientePedido') clientePedido: ClientePedidoComponent;

  // Campanhas
  readonly clienteCampanhaFilter = CAMPANHAS_FILTER_STORAGE_KEY;
  readonly clienteCampanhaPeriodicidadeAnualFilter = periodicidadeAnual;
  readonly clienteCampanhaVisualizacao = CAMPANHAS_VISUALIZACAO_STORAGE_KEY;
  readonly clienteCampanhaModoDashboardVisualizacao = visualizacaoModoDashboard;
  @ViewChild('clienteCampanhas')
  clienteCampanhas: CampanhaViewEmbeddedComponent;

  /** Termo LGPD Form */
  @ViewChild('termoLGPDForm') termoLGPDForm: PessoaTermoLGPDFormComponent;

  // situacoes = clienteSituacoesNutrata;
  situacoes = clienteSituacoes;
  gruposEconomicos: ClienteGrupoEconomico[] = [];
  clienteAbcs = clienteAbcs;
  itensTipo: ItemTipo[] = [];
  moedas = moedas;

  tags: ITokenItem[] = [];
  portfolios: IClientePortfolio[] = [];

  pickListSettings: IPickListSettings = {
    sourceLabel: 'Tags Disponíveis',
    targetLabel: 'Tags Selecionadas',
    emptyResultMessage: 'Nenhuma tag encontrada'
  };

  tokenFieldSettings: ITokenFieldSettings = {
    placeholder: 'Digite suas tags...',
    isDisabled: true,
    isReadOnly: true
  };

  seletorTagsSettings: ISeletorTagsSettings = {
    pickListSettings: this.pickListSettings,
    tokenFieldSettings: this.tokenFieldSettings,
    cadastro: EnumCadastro.CLIENTE
  };

  @Output() afterCancel = new EventEmitter<any>();

  selectPeriodicidadeCompraSettings: ISelectSettings = {
    placeholder: 'Selecione uma periodicidade de compra',
    isDisabled: false,
    required: true,
    requiredFieldMessage: 'A periodicidade de compra é obrigatória',
    isClearSelectionAllowed: false
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private configService: ConfigService,
    private messageService: MessageService,
    private baseFormService: BaseFormService,
    private clienteAuthGuardService: ClienteAuthGuardService,
    private clienteCrudHttpService: ClienteCrudHttpService,
    private clienteGrupoEconomicoCrudHttpService: ClienteGrupoEconomicoCrudHttpService,
    private clienteValidacoesHttpService: ClienteValidacoesHttpService,
    private pessoaCrudHttpService: PessoaCrudHttpService,
    private itemTipoCrudHttpService: ItemTipoCrudHttpService,
    private clienteSecundarioHttpService: ClienteSecundarioHttpService,
    private clienteAnaliseFinanceiraAuthGuardService: ClienteAnaliseFinanceiraAuthGuardService,
    private representanteClassificacaoClienteHttpService: RepresentanteClassificacaoClienteHttpService,
    private clienteIntegracaoEmpresasImportHttpService: ClienteIntegracaoEmpresasImportHttpService,
    private toastService: ToastService
  ) {}

  ngOnInit() {
    this.configEmpresa = this.configService.getEmpresa();
    this.configCliente = this.configService.getCliente();
    this.configMeta = this.configService.getMeta();
    this.isAdminitrador = this.authService.isAdministrador();
    this.isAtendente = this.authService.isAtendente();
    this.isGerente = this.authService.isGerente();
    this.isRepresentante = this.authService.isRepresentante();
    this.isFinanceiro = this.authService.isFinanceiro();

    if (!this.embedded) {
      this.baseFormService.getIdParam(this.activatedRoute).then((id) => {
        if (!id) {
          this.preInsert();
        } else {
          this.edit(id);
        }
      });
    }

    this.searchItensTipo();
  }

  /** Seta as configurações do form */
  private setConfig() {
    this.config = {
      isPessoaFisica: this.isTipoPessoaFisica(),
      isPessoaJuridica: this.isTipoPessoaJuridica(),
      isPessoaFisicaOuJuridica: this.isTipoPessoaFisicaOuJuridica(),
      isCentralCompras: this.isTipoPessoaCentralCompras(),
      canEditOrigem: this.clienteAuthGuardService.canEditOrigem(
        this.editMode,
        this.entity?.origem
      ),
      isModoCentralCompraCadastro: isModoCentralCompraCadastro(
        this.configEmpresa.modoCentralCompra
      ),
      isModoCentralCompraReferencia: isModoCentralCompraReferencia(
        this.configEmpresa.modoCentralCompra
      ),
      isProspect: this.isCadastroProspect(),
      isShowContentTabTitulos: false,
      isShowAtividades: this.editMode,
      // Moeda
      canEditMoeda: this.clienteAuthGuardService.canEditMoeda(
        this.editMode,
        this.entity
      ),
      isMoedaRequired: this.configEmpresa.exportadora,
      // Requireds
      isDataFundacaoRequired:
        this.configCliente.obrigarDataFundacao &&
        this.isTipoPessoaFisicaOuJuridica(),
      // Permissões
      canEdit: this.clienteAuthGuardService.canEdit(this.editMode),
      canEditClienteSegmentos: this.clienteAuthGuardService.canEditClienteSegmentos(this.editMode),
      canEditFichaCadastral: this.clienteAuthGuardService.canEditFichaCadastral(
        this.editMode,
        this.entity
      ),
      canEditTipoFiscal: this.clienteAuthGuardService.canEditTipoFiscal(
        this.editMode
      )
    };

    this.setConfigByOrigem();
  }

  /** Seta as configurações do form conforme a origem do cliente */
  private setConfigByOrigem() {
    if (!this.entity) {
      return;
    }
    // Obtendo a origem do cliente
    const origem = Origem.getById(this.entity.origem);

    // Somente exibe o canal de venda se a origem possuir
    this.config.isOrigemPossuiCanalVenda = origem?.possuiCanalVenda ?? false;
  }

  /** Seta foco conforme a origem */
  setFocus() {
    setTimeout(() => {
      if (!this.entity.origem) {
        this.setFocusOrigem();
      } else {
        if (this.config.isOrigemPossuiCanalVenda) {
          this.setFocusCanalVendaOrigem();
        } else if (this.isOrigemCampanha()) {
          this.setFocusCampanhaOrigem();
        } else if (this.isOrigemMidiaSocial()) {
          this.setFocusCanalMidiaSocial();
        } else if (!this.editMode) {
          this.setFocusCnpjCpf();
        }
      }
    });
  }

  /** Seta foco no select da origem */
  private setFocusOrigem() {
    if (!this.config.canEditOrigem) {
      return;
    }
    this.origemSelect?.setFocus();
  }

  /** Seta foco no select da campanha de origem */
  private setFocusCampanhaOrigem() {
    this.campanhaOrigemSelect?.setFocus();
  }

  /** Seta foco no select do canal da mídia social */
  private setFocusCanalMidiaSocial() {
    this.canalMidiaSocialSelect?.setFocus();
  }

  /** Seta foco no select do canal de venda de origem */
  private setFocusCanalVendaOrigem() {
    this.canalVendaOrigemSelect?.setFocus();
  }

  /** Seta foco no input do CNPJ/CPF */
  private setFocusCnpjCpf() {
    this.pessoaForm?.setFocusCnpjCPF();
  }

  /** Seta foco no input do nome */
  private setFocusNome() {
    this.pessoaForm?.setFocusNome();
  }

  /** Verifica se o Tipo de Mercado da empresa é por Marca */
  isTipoMercadoMarca(): boolean {
    if (!this.configEmpresa) {
      return false;
    }
    return isTipoMercadoMarca(this.configEmpresa.tipoMercado);
  }

  /** Verifica se o Tipo de Mercado da empresa é por Unidade de Negócio */
  isTipoMercadoUnidadeNegocio(): boolean {
    if (!this.configEmpresa) {
      return false;
    }
    return isTipoMercadoUnidadeNegocio(this.configEmpresa.tipoMercado);
  }

  /** Ao alterar a origem */
  onChangeOrigem(origem: number) {
    this.entity.origem = origem;
    this.setConfigByOrigem();
    this.setFocus();
  }

  /** Verifica se a origem do cliente é campanha */
  isOrigemCampanha(): boolean {
    if (!this.entity) {
      return false;
    }
    return OrigemID.isOrigemCampanha(this.entity.origem);
  }

  /** Verifica se a origem do cliente é mídia social */
  isOrigemMidiaSocial(): boolean {
    if (!this.entity) {
      return false;
    }
    return OrigemID.isOrigemMidiaSocial(this.entity.origem);
  }

  /** Verifica se a origem do cliente é e-commerce */
  isOrigemEcommerce(): boolean {
    if (!this.entity) {
      return false;
    }
    return OrigemID.isOrigemEcommerce(this.entity.origem);
  }

  /** Ao alterar a campanha de origem do cliente */
  onChangeCampanhaOrigem(campanhaOrigem: CampanhaSelect) {
    this.entity.campanhaOrigem = mapToCampanha(campanhaOrigem);
  }

  /** Verifica se o tipo da pessoa é Fisica */
  private isTipoPessoaFisica(): boolean {
    return isTipoPessoaFisica(this.entity?.pessoa?.tipo);
  }

  /** Verifica se o tipo da pessoa é Juridica */
  private isTipoPessoaJuridica(): boolean {
    return isTipoPessoaJuridica(this.entity?.pessoa?.tipo);
  }

  /** Verifica se o tipo da pessoa é Física ou Juridica */
  private isTipoPessoaFisicaOuJuridica(): boolean {
    return isTipoPessoaFisicaOuJuridica(this.entity?.pessoa?.tipo);
  }

  /** Verifica se o tipo da pessoa é Central de Compras */
  private isTipoPessoaCentralCompras(): boolean {
    return isTipoPessoaCentralCompras(this.entity?.pessoa?.tipo);
  }

  /** Verifica se o status da revisão do cliente é Pendente */
  isRevisaoPendente(): boolean {
    return isClienteRevisaoStatusPendente(this.entity.revisaoStatus);
  }

  onChangePeriodicidadeCompra(idPeriodicidadeCompra: number) {
    this.entity.idPeriodicidadeCompra = idPeriodicidadeCompra;
  }

  onChangeSemana(idSemana: number | null) {
    this.entity.periodicidadeCompraSemana = idSemana;
  }

  /** Pesquisa todos os tipos de item cadastrados */
  private searchItensTipo() {
    this.itemTipoCrudHttpService.search().subscribe(
      (entities) => (this.itensTipo = entities),
      (error: ApiError) =>
        this.messageService.error(
          error.message,
          'Erro ao pesquisar os Tipos de Itens',
          error
        )
    );
  }

  /** Pesquisa os grupos dos clientes cadastrados */
  private searchGruposEconomicos(grupoEconomicoAtual: ClienteGrupoEconomico) {
    const filter = new ClienteGrupoEconomicoFilter();
    // Somente Ativos
    filter.situacao = clienteGrupoEconomicoAtivo.id;
    // Representante
    if (this.isRepresentante) {
      // Representante logado
      filter.idsRepresentantes = [this.authService.getIdRepresentante()];
    } else if (this.entity.idRepresentante) {
      // Representante do cliente
      filter.idsRepresentantes = [this.entity.idRepresentante];
    }

    this.clienteGrupoEconomicoCrudHttpService
      .searchWithFilter(
        filter,
        ClienteGrupoEconomicoSearchOrderBy.Nome,
        'asc',
        null,
        null
      )
      .subscribe(
        (search) => {
          this.gruposEconomicos = search?.entities;

          // Verificando se o grupo econômico atual do cliente existe no array de grupos econômicos ativos e se não existir adicionda para ser exibido no cliente
          if (grupoEconomicoAtual) {
            if (
              !this.gruposEconomicos.find(
                (grupoEconomicoFilter) =>
                  grupoEconomicoFilter.id === grupoEconomicoAtual.id
              )
            ) {
              this.gruposEconomicos.unshift(grupoEconomicoAtual);
            }
          }
        },
        (error: ApiError) =>
          this.messageService.error(
            error.message,
            'Erro ao pesquisar os grupos econômicos',
            error
          )
      );
  }

  /** Ao selecionar o grupo econômico */
  onChangeGrupoEconomico(idClienteGrupoEconomico: number) {
    this.entity.idClienteGrupoEconomico = idClienteGrupoEconomico;
    this.entity.grupoEconomico = this.gruposEconomicos?.find(
      (grupoEconomicoFilter) =>
        grupoEconomicoFilter.id === idClienteGrupoEconomico
    );
  }

  clear() {
    // this.form?.reset();
    // this.form?.resetForm();
    this.entity = null;
  }

  load(id: number) {
    this.isLoading = true;
    this.clienteCrudHttpService.load(id).subscribe(
      (entity) => {
        // Se não for um cliente do representante
        if (
          this.baseFormService.isRepresentanteAndEntityNotRepresentante(entity)
        ) {
          this.messageService.info(
            'Você não possui permissão para acessar este cadastro de prospect/cliente. Verique seus acessos ou entre em contato com o suporte',
            'Sem permissão'
          );
          this.cancel();
        } else if (
          this.baseFormService.isGerenteOuAtendenteAndEntityNotSeuRepresentante(
            entity ? entity.representante : null
          )
        ) {
          // Se não for um cliente do representante que pertença ao gerente/atendente
          this.messageService.info(
            'Você não possui permissão para acessar este cadastro de prospect/cliente. Verique seus acessos ou entre em contato com o suporte',
            'Sem permissão'
          );
          this.cancel();
        } else {
          this.entity = entity;

          this.tags = this.transformDTOtoTokenItems(entity.tags);
          this.portfolios = entity.portfolios;
          this.afterLoad();
        }

        this.isLoading = false;
      },
      (error: ApiError) => {
        this.messageService.error(
          error.message,
          'Erro ao carregar o cliente',
          error
        );
        this.cancel();
        this.isLoading = false;
      }
    );
  }

  private transformDTOtoTokenItems(tags: ITags[]): ITokenItem[] {
    if (!tags || !tags.length) {
      return [];
    }

    return tags.map((item: ITags) => ({
      id: item.tag.id,
      label: item.tag.nome,
      text: item.tag.descricao,
      isSelected: true
    }));
  }

  onTagsChange(tags: ITokenItem[]): void {
    const selectedTagsIds = tags.map((tag) => ({
      id: this.checkIdTags(tag),
      idItem: this.entity.id,
      idTag: tag.id
    }));

    this.entity.tags = selectedTagsIds;
  }

  onPortfolioChange(portfolios: IPortfolioTree[]) {
    const portfolioDto = portfolios.map((portfolio) => ({
        id: portfolio?.id ?? null,
        idCliente: portfolio.idCliente ?? this.entity.id,
        idPortfolio: portfolio.idPortfolio,
        relevancia: portfolio.relevancia,

        categorias: portfolio.categorias.map((categoria) => ({
            id: categoria.id ?? null,
            idCategoria: categoria.idCategoria,
            relevancia: categoria.relevancia
          }))
      }));

    this.entity.portfolios = portfolioDto;
  }

  checkIdTags(tag: ITokenItem): number | null {
    if (tag && tag.id) {
      return this.entity.tags?.find((t) => t.idTag === tag.id)?.id || null;
    }
    return null;
  }

  private afterLoad() {
    // Pesquisando os grupos econômicos
    this.searchGruposEconomicos(this.entity.grupoEconomico);

    setTimeout(() => {
      // Unidades de Negócios
      this.searchUnidadesNegocios();
    }, 300);

    this.setConfig();
    this.setConfigAnaliseFinanceira();
    // this.setFocus();
  }

  /** Seta os valores conforme config. dos clientes */
  private setConfigValues() {
    if (!this.entity || !this.configCliente) {
      return;
    }
    // Financeiro
    this.entity.modoEnvioBoleto = this.configCliente.modoEnvioBoleto;
    this.entity.pagamentoViaPIX = this.configCliente.pagamentoViaPIX;
    this.entity.enviarPIXPorEmail = this.configCliente.enviarPIXPorEmail;
    this.entity.moeda = this.configCliente.moeda;
  }

  /** Abre o pré-insert do cadastro de um novo prospect/cliente */
  preInsert() {
    this.isShowPreInsertForm = true;
    this.editMode = false;
  }

  /** Ao confirmar o pré-insert de um novo prospect/cliente */
  onConfirmPreInsert(clientePreInsert: ClientePreInsert) {
    if (
      clientePreInsert.isTipoPessoaJuridica() &&
      clientePreInsert.clientePessoaJuridica
    ) {
      // Pessoa Jurídica encontrada
      this.editMode = false;
      this.isShowPreInsertForm = false;
      this.entity = clientePreInsert.clientePessoaJuridica;
      this.entity.pessoa.idEmpresa = this.authService.getIdEmpresa();
      this.entity.pessoa.exterior = clientePreInsert.exterior;
      this.afterInsert();
    } else {
      // Demais
      this.insert(
        origemLancamentoCadastroSogivendas,
        clientePreInsert.tipoPessoa,
        clientePreInsert.cnpjCpf,
        clientePreInsert.exterior
      );
    }

    this.entity.origem = clientePreInsert.origem;
    this.entity.idCampanhaOrigem = clientePreInsert.idCampanhaOrigem;
    this.entity.campanhaOrigem = clientePreInsert.campanhaOrigem;
    this.entity.canalMidiaSocial = clientePreInsert.canalMidiaSocial;
    this.entity.idCanalVendaOrigem = clientePreInsert.idCanalVendaOrigem;
    this.entity.canalVendaOrigem = clientePreInsert.canalVendaOrigem;

    setTimeout(() => {
      this.setConfigByOrigem();
      this.setFocusNome();
    }, 300);
  }

  insert(
    origemCadastro: OrigemLancamentoCadastro,
    tipoPessoaDefault: number = null,
    cnpjCpf: string = null,
    exterior = false
  ) {
    this.editMode = false;
    this.isShowPreInsertForm = false;
    this.entity = new Cliente(origemCadastro);
    this.entity.pessoa.idEmpresa = this.authService.getIdEmpresa();
    this.entity.pessoa.exterior = exterior;

    if (cnpjCpf) {
      this.entity.pessoa.cnpjCpf = cnpjCpf;
      this.onValidarCnpjCpfCadastrado();
    }

    // Setando a cidade e país no endereço principal
    setTimeout(() => this.pessoaEnderecoPrincipal?.setCidadeEPais(), 300);

    // Defaults
    this.tipoPessoaDefault = tipoPessoaDefault;
    if (tipoPessoaDefault) {
      this.entity.pessoa.tipo = tipoPessoaDefault;
    }

    // Setando cadastro e situação do cliente conforme o tipo da pessoa
    this.setCadastroSituacao(this.entity.pessoa.tipo);

    // Setando o tipo de pagamento padrão
    this.entity.tipoPagamento = this.configCliente?.tipoPagamentoPadrao ?? null;

    // Classificações
    setTimeout(async () => {
      await this.clienteClassificacaoForm?.insert();
    }, 0);

    this.afterInsert();
  }

  private afterInsert() {
    // Setando os valores conforme config. dos clientes
    this.setConfigValues();
    // Pesquisando os grupos econômicos
    this.searchGruposEconomicos(null);

    // Se for representante...,
    if (this.isRepresentante) {
      // Atribuimos ele ao cliente
      this.setRepresentanteLogado();
      // Setando as classificações através das classificações padrões do representante
      this.setClassificacoesByRepresentante();
    }

    this.setConfig();
    this.setConfigAnaliseFinanceira();
    this.setFocus();

    // Financeiro
    setTimeout(() => this.financeiroForm?.insert(), 0);
  }

  /** Se for representante, então atribuimos ele ao cliente */
  private setRepresentanteLogado() {
    if (this.isRepresentante) {
      const representante = this.authService.getRepresentante();
      if (representante) {
        this.entity.idRepresentante = representante.id;
        this.entity.representante = representante;
      }
    }
  }

  /** Insere um novo cliente a partir da Prospecção Outbound */
  insertByProspeccaoOutbound(cnpj: string) {
    const origemCadastro = origemLancamentoCadastroProspeccaoOutbound;
    // Executando o insert normal
    this.insert(origemCadastro);
    setTimeout(async () => {
      // Consultando o CNPJ
      await this.onConsultarCnpj(origemCadastro, cnpj);

      // Setando origem do cliente como Prospecção Ativa
      this.entity.origem = Origem.ORIGEM_PROSPECCAO_ATIVA.id;
    }, 0);
  }

  edit(id: number) {
    this.editMode = true;

    // Defaults
    this.tipoPessoaDefault = null;

    this.load(id);
  }

  /** Verifica se o cadastro do cliente é Prospect */
  private isCadastroProspect() {
    if (!this.entity) {
      return false;
    }
    return isClienteCadastroProspect(this.entity.cadastro);
  }

  /** Verifica se o cadastro do cliente é cliente */
  private isCadastroCliente() {
    if (!this.entity) {
      return false;
    }
    return isClienteCadastroCliente(this.entity.cadastro);
  }

  /** Verifica se é obrigatório informar o nome fantasia do cliente */
  isNomeFantasiaRequired(): boolean {
    // Prospect
    if (this.isCadastroProspect()) {
      return this.configCliente?.obrigarNomeFantasiaProspect;
    }
    return true;
  }

  // Verificando se deve obrigatar a informar o representante
  isRepresentanteRequired(): boolean {
    // Prospect
    if (this.isCadastroProspect()) {
      return this.configCliente?.obrigarRepresentanteProspect;
    }

    // Cliente
    return this.configCliente?.obrigarRepresentante;
  }

  /** Seta o cadastro e situação do cliente dependente do tipo da pessoa */
  private setCadastroSituacao(tipoPessoa: number) {
    if (isTipoPessoaCentralCompras(tipoPessoa)) {
      // Central de compras
      this.entity.cadastro = clienteCadastroCliente.id;
      this.entity.situacao = clienteSituacaoAtivo.id;
    } else {
      // Fisica/Juridica
      this.entity.cadastro = clienteCadastroProspect.id;
      this.entity.situacao =
        this.configCliente?.prospectSituacaoInsert ?? clienteSituacaoNovo.id;
    }
  }

  /** Ao alterar o tipo da pessoa */
  onChangeTipoPessoa(tipoPessoa: number) {
    this.config.isPessoaFisica = this.isTipoPessoaFisica();
    this.config.isPessoaJuridica = this.isTipoPessoaJuridica();
    this.config.isPessoaFisicaOuJuridica = this.isTipoPessoaFisicaOuJuridica();
    this.config.isCentralCompras = this.isTipoPessoaCentralCompras();
    this.config.isDataFundacaoRequired =
      this.configCliente.obrigarDataFundacao &&
      this.isTipoPessoaFisicaOuJuridica();

    // Setando o cadastro e situação do cliente conforme o tipo da pessoa quando estiver inserindo um novo cliente
    if (!this.editMode) {
      this.setCadastroSituacao(tipoPessoa);
    }
  }

  /** Ao alterar a flag de cliente do exterior */
  onChangeExterior(exterior: boolean) {
    // Quando for um cliente do exterior, removemos a moeda atualmente seleciona para o usuário verificar a moeda correta do cliente
    if (exterior) {
      this.entity.moeda = null;
    } else {
      // Se não, setamos o Real como moeda do cliente
      this.entity.moeda = moedaReal.id;
    }
  }

  /** Ao alterar o representante no typeahead */
  onTypeaheadChangeRepresentante(representante: Representante) {
    if (representante) {
      this.entity.idRepresentante = representante.id;
    } else {
      this.entity.idRepresentante = null;
    }
  }

  /** Ao selecionar o representante */
  onRepresentanteSelected() {
    // Pesquisando os grupos econômicos
    this.searchGruposEconomicos(this.entity.grupoEconomico);

    // Setando as classificações através das classificações padrões do representante selecionado
    this.setClassificacoesByRepresentante();
  }

  /** Ao remover o representante */
  onClearRepresentante() {
    // Pesquisando os grupos econômicos
    this.searchGruposEconomicos(this.entity.grupoEconomico);
  }

  /** Ao alterar o gerente no typeahead */
  onTypeaheadChangeUsuarioGerente(usuarioGerente: Usuario) {
    this.entity.idUsuarioGerente = usuarioGerente ? usuarioGerente.id : null;
  }

  /** Ao alterar o atendente no typeahead */
  onTypeaheadChangeUsuarioAtendente(usuarioAtendente: Usuario) {
    this.entity.idUsuarioAtendente = usuarioAtendente
      ? usuarioAtendente.id
      : null;
  }

  /** Seta as classificações através das classificações padrões do representante */
  private setClassificacoesByRepresentante() {
    // Se não estiver inserindo um novo cliente e não tiver o representante selecionado então ignoramos
    if (this.editMode || !this.entity.idRepresentante) {
      return;
    }

    // Pesquisando as classificações de cliente do representante selecionado
    this.representanteClassificacaoClienteHttpService
      .search(this.entity.idRepresentante)
      .pipe(take(1))
      .subscribe(
        (classificaoesClientes) => {
          // Percorrendo as classificações de clientes do representante e setando a classificação equivalente ao tipo de classificação
          classificaoesClientes?.forEach((classificacaoCliente) => {
            for (let i = 0; i < this.entity.classificacoes.length; i++) {
              const entityClassificacao = this.entity.classificacoes[i];

              // Setamos quando for o mesmo tipo de classificação
              if (
                entityClassificacao.idTipoClassificacao ===
                classificacaoCliente.idTipoClassificacao
              ) {
                entityClassificacao.idClassificacao =
                  classificacaoCliente.idClassificacao;
                entityClassificacao.classificacao =
                  classificacaoCliente.classificacao;
                break;
              }
            }
          });
        },
        (error: ApiError) => {
          if (this.isRepresentante) {
            this.messageService.error(
              error.message,
              'Ocorreu um erro ao carregar os seus segmentos de clientes padrões. Tente novamente ou informe manualmente os segmentos no cliente',
              error
            );
          } else {
            this.messageService.error(
              error.message,
              'Ocorreu um erro ao carregar os segmentos de clientes padrões do representante selecionado. Tente novamente ou informe manualmente os segmentos no cliente',
              error
            );
          }
        }
      );
  }

  /** Verifica se é obrigatório informar o CEP no endereço */
  isCepRequired(): boolean {
    // Prospect
    if (this.isCadastroProspect()) {
      return this.configCliente?.obrigarCepProspect;
    }

    // Se não for um cliente do exterior e também não for uma central de compras
    return !this.entity.pessoa.exterior && !this.config.isCentralCompras;
  }

  /** Verifica se é obrigatório informar o logradouro no endereço */
  isLogradouroRequired(): boolean {
    // Prospect
    if (this.isCadastroProspect()) {
      return this.configCliente?.obrigarLogradouroProspect;
    }

    // Se não for uma central de compras
    return !this.config.isCentralCompras;
  }

  /** Verifica se é obrigatório informar o número no endereço */
  isNumeroRequired(): boolean {
    // Prospect
    if (this.isCadastroProspect()) {
      return this.configCliente?.obrigarNumeroProspect;
    }

    // Se não for uma central de compras
    return !this.config.isCentralCompras;
  }

  /** Verifica se é obrigatório informar o bairro no endereço */
  isBairroRequired(): boolean {
    // Prospect
    if (this.isCadastroProspect()) {
      return this.configCliente?.obrigarBairroProspect;
    }

    // Se não for um cliente do exterior e também não for uma central de compras
    return !this.entity.pessoa.exterior && !this.config.isCentralCompras;
  }

  /** Verifica se a Inscrição Estadual é obrigatória */
  isInscricaoEstadualRequired(): boolean {
    // Se for uma pessoa física então não deverá ser obrigatório pois CPF não possui IE
    if (this.config.isPessoaFisica) {
      return false;
    }

    // Prospect
    if (this.isCadastroProspect()) {
      return this.configCliente?.obrigarInscricaoEstadualProspect;
    }
    return this.configCliente?.obrigarInscricaoEstadual;
  }

  /** Verifica se é obrigatório informar o telefone no contato */
  isTelefoneRequired(): boolean {
    // Prospect
    if (this.isCadastroProspect()) {
      return this.configCliente?.obrigarFoneProspect;
    }

    // Se não for uma central de compras
    return !this.config.isCentralCompras;
  }

  /** Valida se pode realizar o save */
  private validateSave(): boolean {
    // Sem permissão para editar
    if (!this.config.canEdit) {
      this.messageService.warning(
        'Você não possui permissão para editar este cliente. Verique seus acessos ou entre em contato com o suporte',
        'Sem permissão'
      );
      return false;
    }

    // Se puder editar a origem, então validamos a origem
    if (this.config.canEditOrigem) {
      // Origem não selecionada
      if (!this.origemSelect?.isValid) {
        this.baseFormService.showTabForm('#clienteFormTabPrincipal');
        this.messageService.warning(
          'Selecione a origem deste prospect e tente novamente',
          'Origem do prospect não selecionada',
          notCloseMessageOptions
        );
        setTimeout(() => this.setFocusOrigem(), 300);
        return false;
      }

      // Canal da mídia social
      if (this.isOrigemMidiaSocial() && !this.canalMidiaSocialSelect?.isValid) {
        this.baseFormService.showTabForm('#clienteFormTabPrincipal');
        this.messageService.warning(
          'Selecione o canal da mídia social que gerou este prospect e tente novamente',
          'Canal da mídia social não selecionado',
          notCloseMessageOptions
        );
        setTimeout(() => this.setFocusCanalMidiaSocial(), 300);
        return false;
      }

      // Canal de venda de origem
      if (
        this.config.isOrigemPossuiCanalVenda &&
        !this.canalVendaOrigemSelect?.isValid
      ) {
        this.baseFormService.showTabForm('#clienteFormTabPrincipal');
        this.messageService.warning(
          'Selecione o canal de venda de origem deste prospect e tente novamente',
          'Canal de venda de origem não selecionado',
          notCloseMessageOptions
        );
        setTimeout(() => this.setFocusCanalVendaOrigem(), 300);
        return false;
      }
    }

    // Validando o form da pessoa
    if (!this.pessoaForm?.validateSave()) {
      return false;
    }

    // Simples Nacional
    if (this.simplesNacionalForm && !this.simplesNacionalForm.isValid()) {
      this.baseFormService.showTabForm('#clienteFormTabPrincipal');
      return false;
    }

    // MEI
    if (this.meiForm && !this.meiForm.isValid()) {
      this.baseFormService.showTabForm('#clienteFormTabPrincipal');
      return false;
    }

    // IPI
    if (this.ipiForm && !this.ipiForm.isValid()) {
      this.baseFormService.showTabForm('#clienteFormTabPrincipal');
      return false;
    }

    // Classificações
    if (
      this.clienteClassificacaoForm &&
      !this.clienteClassificacaoForm.isValid()
    ) {
      this.baseFormService.showTabForm('#clienteFormTabClassificacoes');
      return false;
    }

    // Endereço Principal
    if (!this.pessoaEnderecoPrincipal?.isValid()) {
      this.baseFormService.showTabForm('#clienteFormTabEnderecos');
      return false;
    }
    // Endereço Cobrança
    if (this.pessoaEnderecoCobranca && !this.pessoaEnderecoCobranca.isValid()) {
      this.baseFormService.showTabForm('#clienteFormTabEnderecos');
      return false;
    }
    // Endereço Entrega
    if (this.pessoaEnderecoEntrega && !this.pessoaEnderecoEntrega.isValid()) {
      this.baseFormService.showTabForm('#clienteFormTabEnderecos');
      return false;
    }

    // Quando for um cliente pessoa Física ou Juridica
    if (this.config.isPessoaFisicaOuJuridica) {
      // Contatos
      if (this.pessoaOutrosContatosCadastro?.isFormOpen) {
        this.messageService.warning(
          'Salve ou cancele o contato para poder salvar o cliente',
          'Atenção',
          notCloseMessageOptions
        );
        this.baseFormService.showTabForm('#clienteFormTabEnderecos');
        return false;
      }
      // Obrigando informar o contato principal
      if (!this.entity.pessoa.contatoPrincipal) {
        this.messageService.warning(
          'Não é possível salvar o cliente sem o contato principal informado. Informe o contato principal para poder salvar o cliente',
          'Atenção',
          notCloseMessageOptions
        );
        this.baseFormService.showTabForm('#clienteFormTabEnderecos');
        return false;
      }

      // Arquivos
      if (this.clienteArquivos && !this.clienteArquivos.isValid()) {
        this.baseFormService.showTabForm('#clienteFormTabAnexos');
        return false;
      }

      // Unidades de Negócio
      // if (this.isTipoMercadoUnidadeNegocio() && this.clienteUnidadeNegocio && !this.clienteUnidadeNegocio.isValid()) {
      //     this.baseFormService.showTabForm('#clienteFormTabComercial');
      //     return false;
      // }
      // Unidades de Negócio
      if (
        this.isTipoMercadoUnidadeNegocio() &&
        this.clienteUnidadeNegocio &&
        !this.clienteUnidadeNegocio.isValid()
      ) {
        this.baseFormService.showTabForm('#clienteFormTabComercial');
        return false;
      }
      // Tipos de Itens
      if (
        this.configCliente.exibirTipoProduto &&
        this.clienteItemTipoForm &&
        !this.clienteItemTipoForm.isValid()
      ) {
        this.baseFormService.showTabForm('#clienteFormTabComercial');
        return false;
      }

      // Concorrentes
      if (
        this.clienteConcorrenteForm &&
        !this.clienteConcorrenteForm.isValid()
      ) {
        this.baseFormService.showTabForm('#clienteFormTabComercial');
        return false;
      }

      // Internet
      if (this.clienteInternetForm && !this.clienteInternetForm.isValid()) {
        this.messageService.warning(
          'Para salvar é preciso informar corretamente todos os campos destacados em vermelho nos dados de e-mails',
          'Atenção',
          notCloseMessageOptions
        );
        this.baseFormService.showTabForm('#clienteFormTabComercial');
        return false;
      }
    }

    // Quando for uma central de compras
    if (this.config.isCentralCompras) {
      // Validando os participantes da central de compras
      if (!this.clienteCentralCompraParticipanteForm?.isValid()) {
        this.baseFormService.showTabForm(
          '#clienteFormTabParticipantesCentralCompras'
        );
        return false;
      }
    }

    // Financeiro
    if (this.financeiroForm && !this.financeiroForm.isValid()) {
      this.baseFormService.showTabForm('#clienteFormTabFinanceiro');
      return false;
    }

    // Contrato
    if (this.contratoForm && !this.contratoForm.isValid()) {
      this.baseFormService.showTabForm('#clienteFormTabComercial');
      return false;
    }

    // Logística
    if (this.logisticaForm && !this.logisticaForm.isValid()) {
      this.baseFormService.showTabForm('#clienteFormTabLogistica');
      return false;
    }

    // Periodicidade de Compra
    if (!this.entity.idPeriodicidadeCompra) {
      this.toastService.warning(
        'Por favor, informe a periodicidade de compra',
        { duration: 3000 }
      );
      return false;
    }

    return true;
  }

  private beforeSave() {
    // Tipos de Itens
    // if (this.clienteItemTipoForm) {
    //     this.clienteItemTipoForm.resolve();
    // }
    // Concorrentes
    if (this.clienteConcorrenteForm) {
      this.clienteConcorrenteForm.resolve();
    }

    // Unidades de Negócio
    // if (this.isTipoMercadoUnidadeNegocio() && this.clienteUnidadeNegocio) {
    //     this.clienteUnidadeNegocio.resolve();
    // }
    // Unidades de Negócios
    this.entity.unidadesNegocio = this.clienteUnidadeNegocio?.resolve();

    // Prazos de Pagamento
    if (this.clientePrazoPagamentoCadastro) {
      this.clientePrazoPagamentoCadastro.resolve();
    }
    // Internet
    if (this.clienteInternetForm) {
      this.clienteInternetForm.beforeSave();
    }

    // Dados Financeiros
    if (this.financeiroForm) {
      this.financeiroForm.resolve();
    }

    // Contrato
    if (this.contratoForm) {
      this.contratoForm.resolve();
    }

    // Logística
    if (this.logisticaForm) {
      this.logisticaForm.resolve();
    }

    // Confirmação da revisão do cliente
    this.clienteRevisaoConfirmar?.beforeSave();

    // Se não for uma central de compras limpamos o array de participantes
    if (!this.config.isCentralCompras) {
      this.entity.participantesCentralCompra = [];
    }
  }

  async saveClick() {
    try {
      await this.save();
      this.afterSave();
    } catch (error) {
      console.error(error);
    }
  }

  save(): Promise<Cliente> {
    return new Promise<Cliente>((resolve, reject) => {
      try {
        if (this.validateSave()) {
          this.beforeSave();
          this.baseFormService
            .save<Cliente>(
              this.entity,
              this.form,
              this.editMode,
              this.clienteCrudHttpService
            )
            .then((entity) => {
              this.entity = entity;
              this.messageService.success('', 'Cliente salvo com sucesso');
              resolve(entity);
            })
            .catch((error) => reject(error));
        } else {
          reject();
        }
      } catch (error) {
        this.messageService.error(
          'Ocorreu um erro ao tentar salvar o cliente. Tente salvar novamente e se o erro persistir entre em contato com o suporte',
          'Erro ao salvar o cliente',
          error
        );
        reject(error);
      }
    });
  }

  afterSave() {
    this.cancel();
  }

  cancel() {
    if (!this.embedded) {
      this.baseFormService.cancel(this.activatedRoute);
    }

    this.afterCancel.emit();
  }

  /** Realiza a validação de cadastro já existe do cliente e pessoa através do CNPJ/CPF informado */
  onValidarCnpjCpfCadastrado() {
    if (!this.entity && !this.entity.pessoa) {
      return;
    }
    // Se for um cliente do exterior, então ignoramos a validação pois o mesmo não possui um CNPJ
    if (this.entity.pessoa.exterior) {
      return;
    }

    const idPessoa =
      this.entity.pessoa.id && !isNaN(this.entity.pessoa.id)
        ? Number(this.entity.pessoa.id)
        : 0;
    this.clienteValidacoesHttpService
      .getClienteJaCadastrado(
        idPessoa,
        this.entity.pessoa.cnpjCpf,
        this.entity.idRepresentante,
        this.editMode
      )
      .subscribe(
        (validacao) => {
          // 1 - Verificando se o CNPJ Matriz (parte até a "/") já esta cadastrado
          if (validacao.cnpjMatrizJaCadastrado) {
            this.messageService.info(
              'Não é possível cadastrar o cliente por que já existe um cliente cadastrado com o CNPJ da Matriz igual ao informado. Por favor entre em contato com o comercial para mais informações',
              'Informação',
              notCloseMessageOptions
            );
            this.cancel();
            return;
          }

          // 2 - Verificando se o cliente já está cadastrado para o representante ou para a empresa
          if (validacao.jaCadastrado) {
            alert(
              'Já existe um cliente cadastrado com este CNPJ/CPF informado. O seus dados serão carregados'
            );
            // Navegando para o cadastrado do cliente para entrar em modo de edição
            this.router.navigate(['../', validacao.id], {
              relativeTo: this.activatedRoute
            });

            // Quando estiver editiando, precisamos recarregar a página por causa que o route fica igual (mudando apenas o ID)
            if (this.editMode) {
              location.reload();
            }

            return;
            /*this.messageService.confirm('Já existe um cliente cadastrado com este CNPJ/CPF informado. Deseja carregar os seus dados?', 'Confirme').then((result) => {
                            if (result) {
                                // Navegando para o cadastrado do cliente para entrar em modo de edição
                                this.router.navigate(['../', validacao.id], {relativeTo: this.activatedRoute});

                                // Quando estiver editiando, precisamos recarregar a página por causa que o route fica igual (mudando apenas o ID)
                                if (this.editMode) {
                                    location.reload();
                                }
                            }
                        });*/
          }

          // 3 - Sem permissão para cadastrar clientes secundários
          if (validacao.clienteSecundarioNaoPermitido) {
            this.messageService.info(
              'O CNPJ/CPF informado já está cadastrado para outro cliente e não é permitido cadastrar clientes secundários. Entre em contato com o comercial ou o suporte para mais informações',
              'Informação',
              notCloseMessageOptions
            );
            this.cancel();
            return;
          }

          // 4 - Verificando se o cliente já está cadastrado como cliente primario para outro representante ou para a empresa
          if (validacao.clientePrimarioJaCadastrado) {
            this.messageService
              .confirm(
                'Já existe um cliente cadastrado com este CNPJ/CPF informado mas que não pertence a sua carteira de clientes.\n\nDeseja carregar os seus dados e cadastrar esse cliente na sua carteira?',
                'Confirme'
              )
              .then((result) => {
                if (result) {
                  this.createClienteSecundario(validacao.idClientePrimario);
                }
              });

            return;
          }

          // 5 - Verificando se a pessoa já está cadastrada
          if (validacao.pessoaJaCadastrada) {
            this.messageService
              .confirm(
                'Já existe um cadastrado com este CNPJ/CPF informado. Desejar carregar os seus dados?',
                'Confirme'
              )
              .then((result) => {
                if (result) {
                  // Carregando os dados da pessoa
                  this.pessoaCrudHttpService.load(validacao.idPessoa).subscribe(
                    (entityPessoa) => (this.entity.pessoa = entityPessoa),
                    (error: ApiError) =>
                      this.messageService.error(
                        error.message,
                        'Ocorreu um erro ao carregar os dados',
                        error
                      )
                  );
                }
              });

            return;
          }
        },
        (error: ApiError) =>
          this.messageService.error(
            error.message,
            'Ocorreu um erro ao verificar se o já existe um cliente com o CNPJ/CPF cadastrado',
            error
          )
      );
  }

  onConsultarCnpj(
    origemCadastro: OrigemLancamentoCadastro,
    cnpj: string
  ): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      if (this.editMode) {
        this.messageService.warning(
          'Não é possível consultar o CNPJ de um cliente já cadastrado. Tente executar a funcionalidade de atualização cadastral',
          'Atenção',
          notCloseMessageOptions
        );
        return false;
      }

      if (!cnpj || cnpj === '') {
        this.messageService.warning(
          'Informe um CNPJ válido para poder consultá-lo',
          'Atenção'
        );
        this.pessoaForm?.setFocusCnpjCPF();
        reject();
        return;
      }

      this.isConsultandoCnpj = true;
      this.clienteIntegracaoEmpresasImportHttpService
        .consultaCNPJ(cnpj)
        .pipe(take(1))
        .subscribe(
          (response) => {
            this.entity = response;
            // Setando a origem do cadastro após a consulta para alterar para a origem desejada
            if (origemCadastro) {
              this.entity.origemCadastro = origemCadastro.id;
            }

            // Se estiver inserindo
            if (!this.editMode) {
              this.afterInsert();
            }

            this.isConsultandoCnpj = false;
            resolve();
          },
          (error: ApiError) => {
            if (error.status == 404) {
              // Nenhum CNPJ encontrado na base de dados
              this.messageService.warning(
                error.message,
                error.cause,
                notCloseMessageOptions
              );
              this.cancel();
            } else {
              this.messageService.error(error.message, error.cause, error);
            }

            this.isConsultandoCnpj = false;
            reject();
          }
        );
    });
  }

  private createClienteSecundario(idClientePrimario: number) {
    this.clienteSecundarioHttpService
      .createClienteSecundario(idClientePrimario)
      .subscribe(
        (entity) => {
          this.entity = entity;
          // Se for representante, já atribuimos ele ao cliente
          if (this.isRepresentante) {
            const representante = this.authService.getRepresentante();
            if (representante) {
              this.entity.idRepresentante = representante.id;
              this.entity.representante = representante;
            }
          }

          // this.pessoaOutrosContatosCadastro.showTable();
        },
        (error: ApiError) => {
          this.messageService.error(
            error.message,
            'Ocorreu um erro ao carregar os dados do cliente. Tente novamente',
            error
          );
          this.cancel();
        }
      );
  }

  /** Ao alterar o cliente/pessoa matriz no typeahead */
  onTypeaheadChangeClienteMatriz(pessoa: Pessoa) {
    if (pessoa) {
      this.entity.idPessoaMatriz = pessoa.id;
    } else {
      this.entity.idPessoaMatriz = null;
    }
  }

  /** Ao alterar o cliente/pessoa central de compra no typeahead */
  onChangeClienteCentralCompra(cliente: Cliente) {
    if (cliente) {
      this.entity.idClienteCentralCompra = cliente.id;
    } else {
      this.entity.idClienteCentralCompra = null;
    }
  }

  /** Abre o cadastro da central de compras */
  openCentralCompras(idClienteCentralCompra: number) {
    if (!idClienteCentralCompra) {
      return;
    }
    // Abrindo cadastro da central de compras
    this.router.navigate(['../', idClienteCentralCompra], {
      relativeTo: this.activatedRoute
    });
    setTimeout(() => location.reload(), 100);
  }

  /** Análise Financeira */

  /** Seta as configurações da análise financeira do cliente */
  private setConfigAnaliseFinanceira() {
    this.configAnaliseFinanceira = {
      canVisualizarCliente:
        this.clienteAnaliseFinanceiraAuthGuardService.canVisualizarCliente(
          this.entity?.id
        ),
      canRealizar:
        this.clienteAnaliseFinanceiraAuthGuardService.canRealizar() &&
        this.entityAnaliseFinanceira != null &&
        this.entityAnaliseFinanceira !== undefined
    };
  }

  /** Ao alterar a análise financeira do cliente */
  onChangeAnaliseFinanceira(cliente: ClienteAnaliseFinanceira) {
    this.entityAnaliseFinanceira = cliente;
    this.setConfigAnaliseFinanceira();
  }

  /** Após iniciar a análise financeira do cliente */
  onAfterIniciarAnaliseFinanceira(cliente: ClienteAnaliseFinanceira) {
    this.onChangeAnaliseFinanceira(cliente);
  }

  /** Após cancelar o inicio da análise financeira do cliente */
  onAfterCancelarIniciarAnaliseFinanceira(cliente: ClienteAnaliseFinanceira) {
    this.onChangeAnaliseFinanceira(cliente);
  }

  /** Abre modal para concluir a análise financeira do cliente */
  concluirAnaliseFinanceira() {
    this.analiseFinanceiraConcluirModal?.open(this.entityAnaliseFinanceira?.id);
  }

  /** Após concluir a análise financeira do cliente */
  onAfterConcluirAnaliseFinanceira(cliente: ClienteAnaliseFinanceira) {
    this.onChangeAnaliseFinanceira(cliente);
  }

  /** Após cancelar a conclusão da análise financeira do cliente */
  onAfterCancelarConcluirAnaliseFinanceira(cliente: ClienteAnaliseFinanceira) {
    this.onChangeAnaliseFinanceira(cliente);
  }

  /** Abre modal para revisar a análise financeira do cliente */
  revisarAnaliseFinanceira() {
    this.analiseFinanceiraRevisarModal?.open(this.entityAnaliseFinanceira?.id);
  }

  /** Após revisar a análise financeira do cliente */
  onAfterRevisarAnaliseFinanceira(cliente: ClienteAnaliseFinanceira) {
    this.onChangeAnaliseFinanceira(cliente);
  }

  /** Inf. Comerciais */

  /** Verifica se pode editar o retorno do fornecedor */
  canEditRetornoFornecedor(): boolean {
    return this.config.canEdit && (this.isAdminitrador || this.isFinanceiro);
  }

  /** Mercado */

  /** Ao encontrar a classificação de faturamento pretendida */
  onFindClassificacaoFaturamentoPretendida(
    classificacaoFaturamentoPretendida: ClassificacaoFaturamento
  ) {
    if (classificacaoFaturamentoPretendida) {
      this.entity.idClassificacaoFaturamentoPretendida =
        classificacaoFaturamentoPretendida.id;
      this.entity.classificacaoFaturamentoPretendida =
        classificacaoFaturamentoPretendida;
    } else {
      this.entity.idClassificacaoFaturamentoPretendida = null;
      this.entity.classificacaoFaturamentoPretendida = null;
    }
  }

  /** Pesquisa as unidades de negócios do cliente */
  private searchUnidadesNegocios() {
    this.clienteUnidadeNegocio?.search();
  }

  /** Anexos */
  /** Ao clicar na tab dos anexos */
  onTabAnexosClick() {
    setTimeout(() => this.clienteArquivos?.resize(), 0);
  }

  /** Atividades */
  onTabAtividadeClick() {
    this.clienteAtividade?.searchInsideTab();
  }

  /** Ao clicar na tab das campanhas */
  onTabCampanhasClick() {
    setTimeout(() => this.clienteCampanhas?.resize(), 0);
  }

  /** Ao clicar na tab dos pedidos */
  onTabPedidoClick() {
    setTimeout(() => this.clientePedido?.resize(), 0);
  }

  /** Curva ABC de Vendas */

  /** Ao clicar na aba da Curva ABC de Vendas */
  onTabCurvaAbcVendaClick() {
    setTimeout(() => jQuery(window).trigger('resize'), 0);
  }

  /** Termo LGPD */
  async onImprimirTermoLGPD() {
    this.messageService
      .confirm(
        'Para imprimir o Termo LGPD é necessário salvar as atualizações feitas no cliente. Deseja salvar o cliente e imprimir o termo LGPD?',
        'Confirme'
      )
      .then(async (result) => {
        if (result) {
          try {
            await this.save();

            // Se estiver inserindo um novo cliente, então setamos o query param no router para imprimir o Termo LGPD e recarregamos a página no modo de edição
            if (!this.editMode) {
              // Navegando para o cadastrado do novo cliente salvo para entrar em modo de edição
              this.router.navigate(['../', this.entity.id], {
                relativeTo: this.activatedRoute,
                queryParams: { imprimirTermoLGPD: true }
              });
            } else {
              // Se não imprimimos direto
              this.termoLGPDForm?.imprimir();
            }
          } catch (error) {
            console.error(error);
          }
        }
      });
  }

  /** Após imprimir o Termo LGPD */
  afterImprimirTermoLGPD() {
    // Abrindo a aba de anexos
    this.baseFormService.showTabForm('#tabAnexos');
  }

  /** Ao clicar na tab dos títulos */
  onTabTitulosClick() {
    if (!this.config.isShowContentTabTitulos) {
      this.config.isShowContentTabTitulos = true;
      setTimeout(() => this.clienteTitulo?.search([this.entity.pessoa.id]), 0);
    }
  }
}
